import React from "react";
import WeaTextareaNormal from "../base/wea-textarea-normal";
import WeaTextareaLocale from "../base/wea-textarea-locale";
import WeaTools from "../wea-tools";
import middleware from "../../middleware";

class main extends React.Component {
  static defaultProps = {
    inputType: "NORMAl",
    className: "",
    style: {}
  };
  static propTypes = {
    inputType: React.PropTypes.string
  };
  componentDidMount() {
    const isMulti = window.localStorage.getItem("activeLanguageIds");
    if (this.props.inputType.toUpperCase() === "MULTILANG") {
      if (isMulti === null) {
        WeaTools.callApi(
          "/api/system/language/base/getActiveLanguage",
          "GET"
        ).then(res => {
          if (res.activeLanguageIds)
            window.localStorage.setItem(
              "activeLanguageIds",
              JSON.stringify(res.activeLanguageIds)
            );
        });
      }
    }
  }
  setValue(v = "") {
    this.refs.textareaNormal && this.refs.textareaNormal.setValue(v);
  }
  render() {
    const {
      props,
      props: { className, style }
    } = this;
    let isMulti = window.localStorage.getItem("activeLanguageIds") || "[7]";
    try {
      isMulti = JSON.parse(isMulti);
    } catch (error) {
      isMulti = [];
      console.error("获取多语言配置信息失败", error);
    }
    if (props.inputType.toUpperCase() == "FORM") {
      return <input class={className} style={style} />;
    }
    if (props.inputType.toUpperCase() === "MULTILANG" && isMulti.length > 1) {
      return <WeaTextareaLocale {...props} />;
    }
    return <WeaTextareaNormal ref="textareaNormal" {...props} />;
  }
}

const Com = middleware(main, "WeaTextarea");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-textarea/index.js